export default [
  { value: '01', label: '01 (Determination of removed claim or cause)' },
  {
    value: '02',
    label: '02 (Other (e.g. other actions that would have been brought in state court if unrelated to bankruptcy))',
  },
  { value: '11', label: '11 (Recovery of money/property - 542 turnover of property)' },
  { value: '12', label: '12 (Recovery of money/property - 547 preference)' },
  { value: '13', label: '13 (Recovery of money/property - 548 fraudulent transfer)' },
  { value: '14', label: '14 (Recovery of money/property - other)' },
  { value: '21', label: '21 (Validity, priority or extent of lien or other interest in property)' },
  { value: '31', label: '31 (Approval of sale of property of estate and of a co-owner - 363(h))' },
  { value: '41', label: '41 (Objection / revocation of discharge - 727(c),(d),(e))' },
  { value: '424', label: '424 (Obj/Revocation Discharge 727)' },
  { value: '426', label: '426 (Dischargeability 523)' },
  { value: '434', label: '434 (Injunctive Relief)' },
  { value: '435', label: '435 (Validity/Priority/Extent Lien)' },
  { value: '454', label: '454 (Recover Money/Property)' },
  { value: '455', label: '455 (Revoke Plan Confirmation)' },
  { value: '456', label: '456 (Declaratory Judgment)' },
  { value: '457', label: '457 (Subordinate Claim/Interest)' },
  { value: '458', label: '458 (Approval For Sale)' },
  { value: '459', label: '459 (Application For Removal)' },
  { value: '498', label: '498 (Other Action)' },
  { value: '51', label: '51 (Revocation of confirmation)' },
  { value: '61', label: '61 (Dischargeability - 523(a)(5), domestic support)' },
  { value: '62', label: '62 (Dischargeability - 523(a)(2), false pretenses, false representation, actual fraud)' },
  { value: '63', label: '63 (Dischargeability - 523(a)(8), student loan)' },
  { value: '64', label: '64 (Dischargeability - 523(a)(15), divorce/sep property settlement/decree)' },
  { value: '65', label: '65 (Dischargeability - other)' },
  { value: '66', label: '66 (Dischargeability - 523(a)(1),(14),(14A) priority tax claims)' },
  { value: '67', label: '67 (Dischargeability - 523(a)(4), fraud as fiduciary, embezzlement, larceny)' },
  { value: '68', label: '68 (Dischargeability - 523(a)(6), willful and malicious injury)' },
  { value: '71', label: '71 (Injunctive relief - reinstatement of stay)' },
  { value: '72', label: '72 (Injunctive relief - other)' },
  { value: '81', label: '81 (Subordination of claim or interest)' },
  { value: '91', label: '91 (Declaratory judgment)' },
  { value: 'SS', label: 'SS (SIPA Case - 15 U.S.C. 78aaa et.seq.)' },
];



// WEBPACK FOOTER //
// ./src/data/bkNosOptions.js